/* eslint-disable array-callback-return */
import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {SiteService} from "../../sites/site.service";
import {SiteCdfModel, SiteDetailModel, siteDetailModelFactory} from "../../sites/site-detail.model";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowService} from "../workflow.service";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {ContactModel} from "../../contact/contact.model";
import {exposeComponentInDebugMode} from "../../misc/expose-component-in-debug-mode.decorator";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {afterRun} from "../../misc/after-run.decorator";
import {contactTypes} from "../../types/contact";
import {UploaderDialogResult} from "../../uploader-wrapper/uploader-dialog.model";
import {HttpDownloadService} from "../../http/http-download.service";
import {ProjectService} from "../../project/project.service";
import {ProjectModel} from "../../project/project.model";
import {isEqual} from "lodash";
import _ = require("lodash");
import {SiteCdfDialogComponent} from "./site-cdf-dialog.component";
import {ContactService} from "../../contact/contact.service";
import {AreaGroupService} from "../../area-group/area-group.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {SelectItsmContactDialogComponent} from "../project/select-itsm-contact-dialog.component";
import {ItsmAddressModel, itsmSettableAddressesModelFactory, ItsmSiteSettableAddressesModel} from "../../address/itsm-address.model";
import {AddressService} from "../../address/address.service";
import {SelectItsmAddressDialogComponent} from "./select-itsm-address-dialog.component";
import {toggleLoading} from "../../misc/loading.decorator";
import {AppSettingsService} from "../../app-settings/app-settings.service";
import {Subscription} from "rxjs";
import {HasuraGraphqlService} from "../../graphql/hasura-graphql-service";
import {Query} from "../../graphql/query-constant";
import { itsmContactModelListFactory } from "../../contact/itsm-contact.model";
import { TARGET_SYSTEM } from "../../helpers/app-constants";
import { masterAgreementStatusValues } from "../../project/master-agreement-status";

const CAN_EDIT_NAME_STRUCTURE = false;

@Component({
  templateUrl: "./site-details.template.pug",
  providers: [
    SiteService,
    ProjectService,
    AreaGroupService,
    AddressService,
    HasuraGraphqlService,
  ],
})
@exposeComponentInDebugMode()
export class SiteDetailsComponent extends WorkflowStep {
  error: Error;

  projectId: string;
  requireContactForOrderStatus1: boolean = false;
  enableMultipleCA: boolean;
  POR954_TMC: boolean;
  public project: ProjectModel;
  enablePOR0241: boolean = false;
  targetSystem: string;
  subscription: Subscription;
  site: SiteDetailModel = siteDetailModelFactory();
  originalSite: SiteDetailModel = siteDetailModelFactory();
  contractAcc = {
    identifier: "contractAccountId",
  };

  contactTypes: any = contactTypes.filter(it => it.level === "site" && !it.type);
  contactHumanReadableNames: any = contactTypes.filter(it => it.level === "contractualContact");
  saveContactTypes: any = [...contactTypes,...this.contactHumanReadableNames];
  itsmSiteContacts: ContactModel[];
  itsmSiteContactsMap: any;
  itsmSiteContactsWithItsmId: ContactModel[];
  itsmContacts: any = [];
  itsmContactsWithItsmIds: any [];
  itsmContactsWithBpId: any = [];
  nonHpItsmContactsWithBpId: any = [];
  itsmContactsWithBpIdMap: any = {};
  ContractualContactTypes: any = {
    billTo: [],
    accDelMgr: [],
    contractAdmin: [],
    hpInvoice: [],
    sales: [],
    invoice: [],
  };
  billToContactId: string;
  invoiceContactId: string;
  hpInvoiceContactId: string;
  hpContractAdminContactId: string;
  hpAccDeliveryMgrContactId: string;
  hpSalesRepContactId: string;

  groupOptions: { name: string, id: string }[];
  canEditNStr = CAN_EDIT_NAME_STRUCTURE;
  collapseDates = false;
  siteId: string;
  contractAccounts: {name: string, id: string} [];

  itsmAddressInfo: ItsmSiteSettableAddressesModel;
  settableAddresses: ItsmAddressModel[] = [];
  settableAddressesWithItsmBuildingIds: ItsmAddressModel[] = []; // List for the search / add functionality
  settableAddressesMap: any = {};
  settableServiceAddresses: ItsmAddressModel[] = [];
  settableConsumableAddresses: ItsmAddressModel[] = [];

  // Parameters
  addressesInfo: any = {
    physicalAddress: {
      name: "physicalAddress",
      humanReadableTitle: "Site Physical Address",
      id: "physicalAddressId",
      readOnly: true,
      defaultAddress: {
        deliveryType: "DOCK",
        customShippingLabel1: "",
        customShippingLabel2: "",
      },
    },
    consumableAddress: {
      name: "consumableAddress",
      humanReadableTitle: "Consumable Address",
      id: "tonerAddressId",
      readOnly: false,
      defaultAddress: {
        deliveryType: "DOCK",
        customShippingLabel1: "",
        customShippingLabel2: "",
      },
      buildingType: "Consumables",
    },
    serviceAddress: {
      name: "serviceAddress",
      humanReadableTitle: "Service Address",
      id: "serviceAddressId",
      readOnly: false,
      defaultAddress: {
        deliveryType: null,
        customShippingLabel1: "",
        customShippingLabel2: "",
      },
      buildingType: "Service",
    },
  };

  itsmSiteAddressId: string;
  itsmSiteName: string;
  defaultCustomShippingLabel1: string;
  defaultCustomShippingLabel2: string;

  serviceSameAsPhysical: boolean = false;
  consumableSameAsPhysical: boolean = false;
  consumableSameAsService: boolean = false;
  addressCopyFlagNames = {
    serviceSameAsPhysical: "serviceSameAsPhysical",
    consumableSameAsPhysical: "consumableSameAsPhysical",
    consumableSameAsService: "consumableSameAsService",
  };
  isContactRefresh: boolean = true;
  spinRefreshContactButton: boolean = false;
  @ViewChild("siteForm") siteForm;
  private fields: string[] = [
    "name",
    "k2Name",
    "siteCode",
    "estimatedStartDate",
    "customerRequestedDev",
    "estimatedCompleteDate",
    "approvedDate",
    "hardwareOrderDate",
    "actualHardwareOrderDate",
    "deliveryDate",
    "installDate",
    "submissionDate",
    "actualSubmissionDate",
    "completionDate",
    "eotLeaseDate",
    "sourceName",
    "sourceDocumentationLink",
    "estimatedSiteSowSigned",
    "actualDesignCustomerApproval",
    "actualSiteSowSigned",
    "estimatedSiteDiscovery",
    "actualSiteDiscovery",
    "estimatedSiteDesignApproval",
    "actualSiteDesignApproval",
    "estimatedSiteMonitoringEnabled",
    "actualSiteMonitoringEnabled",
    "estimatedSiteReadyToDeploy",
    "actualSiteReadyToDeploy",
    "estimatedSiteDeploymentStart",
    "actualSiteDeploymentStart",
    "estimatedSiteDeploymentEnd",
    "actualSiteDeploymentEnd",
    "estimatedSiteCustomerAcceptance",
    "actualSiteCustomerAcceptance",
    "estimatedSiteHandover",
    "actualSiteHandover",
    "businessPartnerId",
    "defaultAreaGroup",
    "friendlyName",
  ];

  private async loadPartnerPurchaseOrders(sitePartnerPurchaseOrders = []) {
    // get the Project PPOs
    const projectPartnerPOs =
      await this.projectService.getPartnerPurchaseOrders(this.workflowService.workflowConfig.projectId);
    // Compare Site & project PPOs and update sites as needed
    const mergedPPOs = [];
    projectPartnerPOs.forEach((projectPPO) => {
      const sitePPOIndex = sitePartnerPurchaseOrders.findIndex(sitePPO => sitePPO.name === projectPPO.name);
      mergedPPOs.push({name: projectPPO.name, checked: (sitePPOIndex >= 0)});
    });
    // return the merged Partner PPOs
    return mergedPPOs;
  }

  @afterRun((self) => { self.loading = false; })
  @handleErrors()
  async loadData(): Promise<void> {
    this.loading = true;
    const siteId = this.workflowService.workflowConfig.targetId;
    this.targetSystem = this.workflowService.workflowConfig.targetSystem;
    const site = await this.siteService.getSiteById(siteId);
    Query.SITE_DETAILS.variables.siteId = siteId;
    const params = {
      projectId: this.projectId,
      query: Query.SITE_DETAILS,
      uiAction: "SITE-DETAILS",
    };
    Query.SITE_ADDRESS.variables.siteId = site.itsmSiteId;
    const settableAddressParams = {
      projectId: this.projectId,
      query: Query.SITE_ADDRESS,
      uiAction: "SITE-DETAILS",
    };
    const [
      featurePermissions,
      siteDetails,
      settableAddress
    ] = await Promise.all([
      this.appSettingsService.getFeaturePermissionsList(["enableMultipleCA", "POR024", "POR024_1", "POR613-2_TMC"]),
      this.hasuraGqlService.getResponseFromHasura(params),   
      this.hasuraGqlService.getResponseFromHasura(settableAddressParams), 
      this.loadItsmAddresses(),
      this.loadItsmContacts(), 
    ]);
    const [
      multipleCA,
      POR024,
      POR024_1,
      POR613_2
    ] = [
      featurePermissions["enableMultipleCA"],
      featurePermissions["POR024"],
      featurePermissions["POR024_1"],
      featurePermissions["POR613-2_TMC"],
    ];

    this.enableMultipleCA = multipleCA && POR024;
    this.enablePOR0241 = POR024_1;
    // await this.loadItsmAddresses(); // Should be done before getting the site to make sure site has any synced IDS
    // const site = await this.siteService.getSiteById(siteId);
    this.site = site;
    this.originalSite = siteDetailModelFactory(site);
    this.site.partnerPurchaseOrders = await this.loadPartnerPurchaseOrders(this.site.partnerPurchaseOrders);
    if (siteDetails && siteDetails.body && siteDetails.body.data &&
      siteDetails.body.data.site && siteDetails.body.data.site.length > 0) {
      const groups = siteDetails.body.data.site[0].project ? siteDetails.body.data.site[0].project.area_groups : [];
      this.groupOptions = groups.map((item) => {
        if (!this.requireContactForOrderStatus1 && !POR613_2) {
          this.requireContactForOrderStatus1 =
            item.itsmConsumableAutoFulfillment || item.itsmLongLifeConsumableAutoFulfillment ||
            item.doMaintenanceAutoOrder;
        }
        return {
          name: `${item.areaName} - ${item.groupName}`,
          id: item.id,
        };
      });
      this.groupOptions.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (settableAddress && settableAddress.body && settableAddress.body.data &&
      settableAddress.body.data.settableAddresses && settableAddress.body.data.settableAddresses.length > 0) {
      // const itsmSiteId = siteDetails.body.data.site[0].address.siteId;
      // if (siteDetails.body.data.site[0].project.settableAddresses &&
      //   siteDetails.body.data.site[0].project.settableAddresses.length > 0) {
      //   siteDetails.body.data.site[0].project.settableAddresses = siteDetails.body.data
      //     .site[0].project.settableAddresses.filter(_address => _address.itsmSiteId === itsmSiteId);
      // }

      let siteAddress: ItsmSiteSettableAddressesModel = {
        physicalAddressId: siteDetails.body.data.site[0].physicalAddressId,
        tonerAddressId: siteDetails.body.data.site[0].tonerAddressId,
        serviceAddressId: siteDetails.body.data.site[0].serviceAddressId,
        hpInstalledKit: siteDetails.body.data.site[0].hpInstalledKit,
        tmcSiteName: siteDetails.body.data.site[0].tmcSiteName,
        defaultCustomShippingLabel1: siteDetails.body.data.site[0].project ?
          siteDetails.body.data.site[0].project.defaultCustomShippingLabel1 : "",
        defaultCustomShippingLabel2: siteDetails.body.data.site[0].project ?
          siteDetails.body.data.site[0].project.defaultCustomShippingLabel2 : "",
        itsmSiteAddressId: site.itsmSiteId,
        itsmSiteName: settableAddress.body.data.settableAddresses &&
          settableAddress.body.data.settableAddresses.length > 0 ?
          settableAddress.body.data.settableAddresses[0].itsmSiteName : "",
        settableAddresses: settableAddress.body.data.settableAddresses &&
          settableAddress.body.data.settableAddresses.length > 0 ?
          settableAddress.body.data.settableAddresses : [],
      };
      siteAddress = itsmSettableAddressesModelFactory(siteAddress);
      if (siteDetails.errors && siteDetails.errors.length) {
        this.error = new Error(siteDetails.errors.join(".   "));
      }
      this.itsmAddressInfo = siteAddress;
      this.settableAddresses = siteAddress.settableAddresses;
      this.settableServiceAddresses = siteAddress.settableAddresses.filter(it => it && it.buildingTypes &&
        it.buildingTypes.includes(this.addressesInfo.serviceAddress.buildingType));
      this.settableConsumableAddresses = siteAddress.settableAddresses.filter(it => it && it.buildingTypes &&
        it.buildingTypes.includes(this.addressesInfo.consumableAddress.buildingType));
      this.updateItsmAddressMapsHelper();
      this.site.physicalAddressId = siteAddress.physicalAddressId;
      this.site.tonerAddressId = siteAddress.tonerAddressId;
      this.site.serviceAddressId = siteAddress.serviceAddressId;

      this.itsmSiteAddressId = siteAddress.itsmSiteAddressId;
      this.itsmSiteName = siteAddress.itsmSiteName;

      this.defaultCustomShippingLabel1 = siteAddress.defaultCustomShippingLabel1;
      this.defaultCustomShippingLabel2 = siteAddress.defaultCustomShippingLabel2;
      Object.values(this.addressesInfo).forEach(({defaultAddress}) => {
        if (defaultAddress) {
          if (this.defaultCustomShippingLabel1) defaultAddress.customShippingLabel1 = this.defaultCustomShippingLabel1;
          if (this.defaultCustomShippingLabel2) defaultAddress.customShippingLabel2 = this.defaultCustomShippingLabel2;
        }
      });
    }
    if (this.enableMultipleCA) {
      try {
        if (siteDetails && siteDetails.body && siteDetails.body.data &&
          siteDetails.body.data.site && siteDetails.body.data.site.length > 0 &&
          siteDetails.body.data.site[0].project) {
            if(!this.site.billToContactId) {
              this.site.billToContactId = siteDetails.body.data.site[0].project.billToContactId;
            }
            if(!this.site.invoiceContactId) {
              this.site.invoiceContactId = siteDetails.body.data.site[0].project.invoiceContactId;
            }
            if(!this.site.hpInvoiceContactId) {
              this.site.hpInvoiceContactId = siteDetails.body.data.site[0].project.hpInvoiceContactId;
            }
            if(!this.site.hpContractAdminContactId) {
              this.site.hpContractAdminContactId = siteDetails.body.data.site[0].project.hpContractAdminContactId;
            }
            if(!this.site.hpAccDeliveryMgrContactId) {
              this.site.hpAccDeliveryMgrContactId = siteDetails.body.data.site[0].project.hpAccDeliveryMgrContactId;
            }
            if(!this.site.hpSalesRepContactId) {
              this.site.hpSalesRepContactId = siteDetails.body.data.site[0].project.hpSalesRepContactId;
            }
          let contractAccountData = siteDetails.body.data.site[0].project.target_system === "pmpsp" ||
            siteDetails.body.data.site[0].project.target_system === "mimp" ||
            siteDetails.body.data.site[0].project.target_system === "mpflexr" ||
            siteDetails.body.data.site[0].project.target_system === TARGET_SYSTEM.PMPS_SELL_THROUGH ?
            siteDetails.body.data.site[0].project.partnerContractAccounts ?
              siteDetails.body.data.site[0].project.partnerContractAccounts.contract_accounts : [] :
            siteDetails.body.data.site[0].project.customerContractAccounts ?
              siteDetails.body.data.site[0].project.customerContractAccounts.contract_accounts : [];
          contractAccountData = (contractAccountData
            .filter(it => it.status) || []).sort(this.contractAccountSortHelper);
          if (contractAccountData.length === 1) {
            this.site.contractAccountId = contractAccountData[0].contractAccountId;
          }
          const projectOpportunityId = siteDetails.body.data.site[0].project.opportunityId;
          this.contractAccounts = contractAccountData.map((item) => {
            let contractAcct;
            if (this.enablePOR0241 && projectOpportunityId &&
              !item.contracts.find(contract => contract.opportunityId === projectOpportunityId)) {
              contractAcct = undefined;
            } else {
              contractAcct = {
                name: item.contractAccountName,
                id: item.contractAccountId,
              };
            }
            return contractAcct;
          }).filter(account => account !== undefined);
        }
      } catch (error) {
        this.error = new Error("Contract Account Error");
      }
    }
    // this.syncContacts(siteDetails)
  }

  syncContacts(siteDetails): any {
    if (siteDetails && siteDetails.body && siteDetails.body.data &&
      siteDetails.body.data.site && siteDetails.body.data.site.length > 0) {
        this.billToContactId = siteDetails.body.data.site[0].billToContactId;
        this.invoiceContactId = siteDetails.body.data.site[0].invoiceContactId;
        this.hpAccDeliveryMgrContactId = siteDetails.body.data.site[0].hpAccDeliveryMgrContactId;
        this.hpContractAdminContactId = siteDetails.body.data.site[0].hpContractAdminContactId;
        this.hpInvoiceContactId = siteDetails.body.data.site[0].hpInvoiceContactId;
        this.hpSalesRepContactId = siteDetails.body.data.site[0].hpSalesRepContactId;
      }
  }
  updateItsmContactMapsHelper() {
    this.itsmSiteContacts.sort((a, b) => {
      if ((a.emailAddress || "").toLowerCase() > (b.emailAddress || "").toLowerCase()) return 1;
      return -1;
    });
    this.itsmSiteContactsMap = this.itsmSiteContacts.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
    this.itsmSiteContactsWithItsmId = this.itsmSiteContacts.filter(it => !!it.itsmContactId);
  }

  private contractAccountSortHelper(a, b) {
    if (!a || !b || !a.contractAccountName || !b.contractAccountName) return 0;
    if (a.contractAccountName > b.contractAccountName) return 1;
    if (a.contractAccountName < b.contractAccountName) return -1;
    return 0;
  }

  async loadItsmAddresses() {
    // REQUIRES - this.projectId to be set
    // Must be called before the main call to retrieve the project
    Query.GLOBAL_OPP_ID.variables.projectId = this.projectId;
    const params: any = {
      projectId: this.projectId,
      uiAction: "SITE-CONTACT",
      queryType: "Global-Deal",
      query: Query.GLOBAL_OPP_ID,
    };
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);
    let contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    contacts = _.uniqBy(contacts, "itsmContactId");
    contacts = itsmContactModelListFactory(contacts);
    // contacts.forEach(item => item.name = `${item.firstName} ${item.lastName}`);
    let itsmSiteContacts;
    if (this.targetSystem === TARGET_SYSTEM.PMPS_PAGE ||
      this.targetSystem === TARGET_SYSTEM.MIGRATION_IPSO_PAGE ||
      this.targetSystem === TARGET_SYSTEM.MP_FLEX_RESELL ||
      this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH
      ) {
      itsmSiteContacts = contacts.filter((_contact) => {
        if (_contact.resellerCustomerId && _contact.relatedAccountIds &&
            _contact.relatedAccountIds.find(rc => rc === _contact.resellerCustomerId)) {
          return _contact;
        }
      });
    } else {
      itsmSiteContacts = contacts;
    }
    // const itsmSiteContacts = await this.siteService.getItsmContacts(this.workflowService.workflowConfig.targetId);
    this.itsmSiteContacts = itsmSiteContacts && itsmSiteContacts.length ? itsmSiteContacts : [];
    this.updateItsmContactMapsHelper();
  }

  @afterRun((self) => { self.loading = false; })
  @handleErrors()
  async loadContacts(): Promise<void> {
    this.loading = true;

    await this.loadItsmAddresses();

    const siteId = this.workflowService.workflowConfig.targetId;
    const site = await this.siteService.getSiteById(siteId);
    this.contactTypes.forEach(({field, identifier}) => {
      // Copy over only the new contacts
      this.site[field] = site[field];
      this.site[identifier] = site[identifier];
    });
  }

  async ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.projectId = workflowTargetInfo.projectId;
    await this.loadData();
  }

  constructor(
    private siteService: SiteService,
    private projectService: ProjectService,
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public dialogService: DialogService,
    private httpDownloadService: HttpDownloadService,
    private contactService: ContactService,
    private areaGroupService: AreaGroupService,
    private addressService: AddressService,
    private appSettingsService: AppSettingsService,
    private hasuraGqlService: HasuraGraphqlService,
  ) {
    super(true);
  }

  @toggleLoading()
  @handleErrors()
  async autoSave(): Promise<boolean> {
    this.site.partnerPurchaseOrders = this.site.partnerPurchaseOrders
      .filter(sPPO => sPPO.checked);
    if (this.contractAccounts && this.contractAccounts.length > 0) {
      const matchedContract = this.contractAccounts.find(
        contractName => contractName.id === this.site.contractAccountId,
      );
      this.site.contractAccountName = matchedContract ? matchedContract.name : null;
    }
    await this.siteService.saveSite(this.site);

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);
    return true;
  }

  @handleErrors()
  public async selectContact(selectedTmcContactId, contactType): Promise<void> {
    const allowCreate = true;
    const requireBpId = false;

    const contactTypeInfo = this.contactTypes.find(it => it.field === contactType);
    if (!contactTypeInfo) throw new Error("Unknown contact type");

    const modalResults = await (SelectItsmContactDialogComponent.showContactModal(
      this.dialogService,
      {
        projectId: this.projectId,
        contactService: this.contactService,
        allowCreate,
        requireBpId,
        selectedTmcContactId,
        itsmContacts: this.itsmSiteContactsWithItsmId,
        titleModifier: contactTypeInfo.name,
      },
    ));

    if (modalResults && modalResults.changed) {
      const foundContact = this.itsmSiteContacts.find(it => it.id === modalResults.selectedContactId);
      if (
        allowCreate &&
        !foundContact &&
        modalResults.createdContact &&
        modalResults.createdContact.id &&
        modalResults.createdContact.itsmContactId
      ) {
        // Update our list of contacts to include the newly created contact
        this.itsmSiteContacts.push(modalResults.createdContact);
        this.updateItsmContactMapsHelper();
        this.site[contactTypeInfo.identifier] = modalResults.selectedContactId;
      } else if (foundContact) {
        this.site[contactTypeInfo.identifier] = modalResults.selectedContactId;
      } else {
        this.error = new Error("Selected contact not recognized");
      }
    }
  }

  private contactsAreDirty() {
    if (!this.saveContactTypes) return false;
    if (!this.site["tonerContactId"] || !this.site["orderStatusNot1ContactId"]) return true; // Force to set this contacts even if the form is not dirty
    for (const {identifier} of this.saveContactTypes) {
      if (this.site[identifier] !== this.originalSite[identifier]) return true;
    }
    return false;
  }

  private checkContractAccountAreDirty() {
    if (this.site.contractAccountId !== this.originalSite.contractAccountId) {
      return true;
    }
    return false;
  }

  private checkPartnerPurchaseOrdersAreDirty() {
    const newPO = this.site.partnerPurchaseOrders.filter(sPPO => sPPO.checked)
      .map(ppo => ppo.name);
    const oldPO = this.originalSite.partnerPurchaseOrders
      .map(ppo => ppo.name);
    return !isEqual(newPO, oldPO);
  }

  private checkCdfsAreDirty() {
    return !isEqual(this.site.cdfs, this.originalSite.cdfs);
  }

  private checkBusinessPartnetId() {
    return !this.site.businessPartnerId;
  }

  private checkAddressAreDirty() {
    if (this.site.tonerAddressId !== this.itsmAddressInfo.tonerAddressId) return true;
    if (this.site.serviceAddressId !== this.itsmAddressInfo.serviceAddressId) return true;

    return false;
  }
  async loadItsmContacts() {
    // REQUIRES - this.projectId to be set
    // Must be called before the main call to retrieve the project
    this.POR954_TMC = await this.appSettingsService.getFeaturePermission("POR954_TMC", this.projectId);
    if(this.POR954_TMC) {
      await this.projectService.getItsmContacts(this.projectId, false, true);

    }

    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
    };
    if (this.targetSystem === "pmpsp" || this.targetSystem === "mimp" ||
    this.targetSystem === "mpflexr" || this.targetSystem === TARGET_SYSTEM.PMPS_SELL_THROUGH ||
    this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) {
      params.query = this.POR954_TMC ? Query.PARTNER_CONTACTS_WITH_ACTIVE_FILTER : Query.PARTNER_CONTACTS;
    } else {
      params.query = this.POR954_TMC ? Query.CUSTOMER_CONTACTS_WITH_ACTIVE_FILTER : Query.CUSTOMER_CONTACTS;
    }

    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);

    const contacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    // const contacts = await this.projectService.getItsmContacts(this.projectId);

    if (this.targetSystem === TARGET_SYSTEM.PMPS_BILL_THROUGH) await this.getHpInvoiceContact(contacts);

   this.setItsmContacts(contacts);
    return this.itsmContacts;
  }

  setItsmContacts(contacts) {
    if (contacts.length) {
      contacts.forEach(contact => contact.name = `${contact.firstName} ${contact.lastName}`);
      this.itsmContacts = contacts;
      this.itsmContactsWithItsmIds = this.itsmContacts.filter(it => it.itsmContactId);
      this.itsmContactsWithBpId = contacts.filter(it => it.businessPartnerId);
      this.nonHpItsmContactsWithBpId = this.itsmContactsWithBpId.filter(it => !it.isHpContact);
      this.itsmContactsWithBpIdMap =
        this.itsmContactsWithBpId.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
      this.buildContactTypes();
    }
  }

  buildContactTypes() {
    for (const contact of this.itsmContactsWithBpId) {
      if (!contact.isHpContact) {
        this.ContractualContactTypes.billTo.push(contact);
        this.ContractualContactTypes.invoice.push(contact);
      } else if (contact.contactTypes) {
        Object.keys(contact.contactTypes).forEach((type) => {
          if (type !== "billTo" && type !== "invoice" && this.ContractualContactTypes[type]) {
            this.ContractualContactTypes[type].push(contact);
          }
        });
      }
    }

    const contactTypesArray = Object.keys(this.ContractualContactTypes);
    for (const type of contactTypesArray) {
      if (!this.ContractualContactTypes[type].length && (type === "billTo" || type === "invoice")) {
        this.ContractualContactTypes[type] = this.nonHpItsmContactsWithBpId;
      } else if (!this.POR954_TMC && !this.ContractualContactTypes[type].length) this.ContractualContactTypes[type] = this.itsmContactsWithBpId;
    }
  }
  async getHpInvoiceContact(contacts) {
    const params: any = {
      projectId: this.projectId,
      uiAction: "PROJECT-CONTACT",
      queryType: "Contact",
      query: Query.CUSTOMER_CONTACTS,
    };
    const contactResponse = await this.hasuraGqlService.getResponseFromHasura(params);
    contacts.forEach((itm) => {
      if (itm.contactTypes && itm.contactTypes["hpInvoice"] === true) {
        itm.contactTypes["hpInvoice"] = false;
      }
    });
    const customerContacts = contactResponse && contactResponse.body && contactResponse.body.data &&
      contactResponse.body.data.contacts && contactResponse.body.data.contacts.length > 0 ?
      contactResponse.body.data.contacts : [];
    customerContacts.forEach((contact) => {
      if (contact.contactTypes && contact.contactTypes["hpInvoice"] === true) contacts.push(contact);
    });
  }

  makeAddressesConsistentWithFlagsHelper() {
    // To be called after a change (dropdown, search/add, or flag toggle)
    if (this.serviceSameAsPhysical) {
      this.site.serviceAddressId = this.site.physicalAddressId;
      this.addressesInfo.serviceAddress.readOnly = true;
    } else this.addressesInfo.serviceAddress.readOnly = false;

    if (this.consumableSameAsPhysical) {
      this.site.tonerAddressId = this.site.physicalAddressId;
      this.consumableSameAsService = false;
      this.addressesInfo.consumableAddress.readOnly = true;
    }
    if (this.consumableSameAsService) {
      // Must come after the serviceSameAsPhysical check for obvious reasons
      this.site.tonerAddressId = this.site.serviceAddressId;
      this.consumableSameAsPhysical = false;
      this.addressesInfo.consumableAddress.readOnly = true;
    }
    if (!this.consumableSameAsPhysical && !this.consumableSameAsService) {
      this.addressesInfo.consumableAddress.readOnly = false;
    }
  }

  checkDirty(): boolean {
    return this.fields.some(field => this.site[field] !== this.originalSite[field]) ||
      this.checkPartnerPurchaseOrdersAreDirty() ||
      this.checkCdfsAreDirty() ||
      this.checkBusinessPartnetId() ||
      this.contactsAreDirty() ||
      this.checkAddressAreDirty() ||
      this.checkContractAccountAreDirty();
  }

  updateItsmAddressMapsHelper() {
    this.settableAddresses.sort((a, b) => {
      if ((a.itsmName || "").toLowerCase() > (b.itsmName || "").toLowerCase()) return 1;
      return -1;
    });

    this.settableAddressesWithItsmBuildingIds = this.settableAddresses.filter(it => it.itsmBuildingId);
    this.settableAddressesMap = this.settableAddresses.reduce((acc, it) => { acc[it.id] = it; return acc; }, {});
  }

  copyValues(checkFlag): void {
    if (this[checkFlag]) {
      // Handle un-checking any flag that we need to. Must be done before making addresses consistent
      switch (checkFlag) {
        case this.addressCopyFlagNames.consumableSameAsPhysical:
          this.consumableSameAsService = false;
          break;
        case this.addressCopyFlagNames.consumableSameAsService:
          this.consumableSameAsPhysical = false;
          break;
        default:
      }
    }
    // Handle if we've changed an address
    this.makeAddressesConsistentWithFlagsHelper();
  }

  @handleErrors()
  public async selectAddress(addressType: string, hideDeliveryType: boolean = false): Promise<void> {
    const allowCreate = true;
    const requireBpId = false;
    const addressTypeInfo = this.addressesInfo[addressType];
    if (!addressTypeInfo) {
      this.error = new Error("Address type not recognized");
      return;
    }

    const selectedTmcAddressId = this[addressTypeInfo.id] || "";

    const modalResults = await (SelectItsmAddressDialogComponent.showAddressModal(
      this.dialogService,
      {
        projectId: this.projectId,
        allowCreate,
        requireBpId,
        selectedTmcAddressId,
        itsmSiteId: this.itsmSiteAddressId,
        itsmSiteName: this.itsmSiteName,
        itsmAddresses: this.settableAddressesWithItsmBuildingIds,
        addressService: this.addressService,
        targetSystem: this.workflowService.workflowConfig.targetSystem,
        defaultAddress: addressTypeInfo.defaultAddress || {},
        titleModifier: addressTypeInfo.humanReadableTitle,
        hideDeliveryType: hideDeliveryType || false,
        buildingType: addressTypeInfo.buildingType,
      },
    ));

    if (modalResults && modalResults.changed) {
      const foundAddress = this.settableAddresses.find(it => it.id === modalResults.selectedTmcAddressId);
      if (
        allowCreate &&
        !foundAddress &&
        modalResults.createdAddress &&
        modalResults.createdAddress.id &&
        modalResults.createdAddress.itsmBuildingId
      ) {
        // Update our list of addresses to include the newly created address
        this.settableAddresses.push(modalResults.createdAddress);
        this.updateItsmAddressMapsHelper();
        this.site[addressTypeInfo.id] = modalResults.selectedTmcAddressId;
        if (modalResults.createdAddress.buildingTypes.includes(this.addressesInfo.serviceAddress.buildingType)) {
          this.settableServiceAddresses.push(modalResults.createdAddress);
          this.site[this.addressesInfo.serviceAddress.id] = modalResults.selectedTmcAddressId;
        }
        if (modalResults.createdAddress.buildingTypes.includes(this.addressesInfo.consumableAddress.buildingType)) {
          this.settableConsumableAddresses.push(modalResults.createdAddress);
          this.site[this.addressesInfo.consumableAddress.id] = modalResults.selectedTmcAddressId;
        }
      } else if (foundAddress) {
        if (foundAddress.buildingTypes.includes(this.addressesInfo.serviceAddress.buildingType) &&
          addressTypeInfo.id === this.addressesInfo.serviceAddress.id) {
          this.site[this.addressesInfo.serviceAddress.id] = modalResults.selectedTmcAddressId;
        }
        if (foundAddress.buildingTypes.includes(this.addressesInfo.consumableAddress.buildingType) &&
          addressTypeInfo.id === this.addressesInfo.consumableAddress.id) {
          this.site[this.addressesInfo.consumableAddress.id] = modalResults.selectedTmcAddressId;
        }
      }
      this.makeAddressesConsistentWithFlagsHelper();
    }
  }

  @handleErrors()
  async editCdf(cdf?: SiteCdfModel) {
    if (!cdf) {
      cdf = {id: "", system: "portico", buildings: []};
      this.site.cdfs.push(cdf);
    }

    const result = await SiteCdfDialogComponent.showCreateDialog(this.dialogService, cdf);

    if (result.id) {
      Object.assign(cdf, result);

      const flags = this.workflowService.workflowConfig.flags;
      if (!flags["importCdfDdl"] && !flags["importCdfTl"]) {
        this.workflowService.setWorkflowFlag("importCdfTl", true);
      }
    } else {
      const index = this.site.cdfs.indexOf(cdf);

      if (index >= 0) {
        this.site.cdfs.splice(index, 1);
      }
    }
  }

  async importContactsClosed(event: any): Promise<void> {
    const result = event["value"] as UploaderDialogResult;
    if (result.responses.length) {
      await this.loadContacts();
    }
  }

  @handleErrors()
  async download() {
    await this.httpDownloadService.downloadXHR("/api/sites/export-contacts", {siteId: this.site.id});
  }

  onDateFormClose() {
    if (this.collapseDates) {
      this.fields.filter(field => field.toUpperCase().includes("DATE") || field.includes("estimated") || field.includes("actual"))
        .forEach((field) => {
          this.site[field] = "";
        });
      this.collapseDates = false;
    } else {
      this.collapseDates = true;
    }
  }

  async syncContractualContacts(){
    this.spinRefreshContactButton = true;
    await this.siteService.updateContractualContacts(this.projectId);
    this.spinRefreshContactButton = false
  }
}
